import loadable from 'components/dynamic-import';
import { PagesModules } from '@streamloots/streamloots-types';

const PublicModuleLanding = loadable(() => import('./PublicModuleLanding'));

export const SubscriptionsModulePublicLandingPage = (): JSX.Element => {
  return <PublicModuleLanding module={PagesModules.Subscriptions} />;
};
